// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"c63926fa","155":"b0b4b84a","227":"d7fc4d27","310":"2610122e","339":"62d6e393","396":"66c933a8","520":"c64e8b61","601":"57ad9aed"}[chunkId] + ".chunk.js";
};